import { useState, useRef } from 'react';

const BASE_URL = 'https://vidrosthelux.com.br/videos';

const videos = [
  {
    id: 1,
    titulo: 'Fechamento de Sacada Articulada Sem Roldana',
    descricao: 'Veja como funciona o sistema articulado sem roldana em um apartamento de alto padrão.',
    arquivo: 'fechamento-sacada-articulada.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=luxury%20apartment%20balcony%20frameless%20glass%20enclosure%20articulated%20panels%20open%20view%20S%C3%A3o%20Paulo%20modern%20architecture%20premium%20finish&width=640&height=360&seq=vid001&orientation=landscape',
  },
  {
    id: 2,
    titulo: 'Instalação de Box para Banheiro Elegance',
    descricao: 'Processo completo de instalação do box Elegance com acabamento premium.',
    arquivo: 'box-banheiro-elegance.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=luxury%20bathroom%20frameless%20glass%20shower%20box%20installation%20elegant%20modern%20design%20premium%20finish%20white%20tiles%20minimal&width=640&height=360&seq=vid002&orientation=landscape',
  },
  {
    id: 3,
    titulo: 'Guarda-corpo de Vidro Temperado com NBR 7199',
    descricao: 'Instalação de guarda-corpo em conformidade com a norma NBR 7199.',
    arquivo: 'guarda-corpo-vidro-temperado.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=glass%20railing%20guardrail%20installation%20modern%20luxury%20apartment%20building%20transparent%20tempered%20glass%20premium%20hardware%20minimal%20design&width=640&height=360&seq=vid003&orientation=landscape',
  },
  {
    id: 4,
    titulo: 'Espelhos Sob Medida — Projeto Residencial',
    descricao: 'Transformação de ambiente com espelhos sob medida e lapidação especial.',
    arquivo: 'espelhos-sob-medida.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=custom%20mirror%20wall%20panel%20interior%20design%20luxury%20apartment%20modern%20minimal%20elegant%20large%20format%20glass%20reflection%20premium%20finish%20installation&width=640&height=360&seq=vid004&orientation=landscape',
  },
  {
    id: 5,
    titulo: 'Fachada Comercial em Vidro — São Paulo',
    descricao: 'Projeto completo de fachada comercial com vidro de controle solar.',
    arquivo: 'fachada-comercial-vidro.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=commercial%20glass%20facade%20modern%20office%20building%20S%C3%A3o%20Paulo%20energy%20efficient%20curtain%20wall%20exterior%20architecture%20premium%20contemporary%20design&width=640&height=360&seq=vid005&orientation=landscape',
  },
  {
    id: 6,
    titulo: 'Divisórias de Vidro para Home Office',
    descricao: 'Divisórias elegantes que transformam o ambiente de trabalho em casa.',
    arquivo: 'divisorias-home-office.mp4',
    thumb: 'https://readdy.ai/api/search-image?query=glass%20partition%20wall%20interior%20home%20office%20modern%20frameless%20sliding%20glass%20door%20divider%20minimal%20design%20premium%20finish%20elegant%20workspace&width=640&height=360&seq=vid006&orientation=landscape',
  },
];

export default function GaleriaVideos() {
  const [ativo, setAtivo] = useState(0);
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const carrosselRef = useRef<HTMLDivElement>(null);

  const handleSelect = (idx: number) => {
    setAtivo(idx);
    setPlaying(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.load();
    }
  };

  const handlePlay = () => {
    setPlaying(true);
    videoRef.current?.play();
  };

  const scroll = (dir: 'left' | 'right') => {
    if (carrosselRef.current) {
      carrosselRef.current.scrollBy({ left: dir === 'left' ? -220 : 220, behavior: 'smooth' });
    }
  };

  const videoAtivo = videos[ativo];

  return (
    <section id="galeria-videos" className="py-16 md:py-24 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-400 uppercase mb-3">
            GALERIA DE VÍDEOS
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight">
            Veja Nossos Projetos em Ação
          </h2>
          <p className="text-white/50 mt-3 text-sm max-w-xl mx-auto">
            Assista aos nossos trabalhos realizados e comprove a qualidade e o acabamento premium da Vidros Thelux.
          </p>
        </div>

        {/* Player principal */}
        <div className="relative rounded-2xl overflow-hidden bg-black mb-6 w-full" style={{ aspectRatio: '16/9' }}>
          <video
            ref={videoRef}
            key={videoAtivo.arquivo}
            className="w-full h-full object-cover"
            poster={videoAtivo.thumb}
            controls={playing}
            preload="none"
            onEnded={() => setPlaying(false)}
          >
            <source src={`${BASE_URL}/${videoAtivo.arquivo}`} type="video/mp4" />
            Seu navegador não suporta vídeo HTML5.
          </video>

          {/* Overlay play */}
          {!playing && (
            <div
              className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer group"
              onClick={handlePlay}
            >
              <img
                src={videoAtivo.thumb}
                alt={videoAtivo.titulo}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-200"></div>
              <div className="relative z-10 flex flex-col items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-500 group-hover:bg-amber-400 transition-colors duration-200 group-hover:scale-110 transform">
                  <i className="ri-play-fill text-white text-3xl ml-1"></i>
                </div>
                <div className="text-center px-4">
                  <p className="text-white font-bold text-base md:text-lg drop-shadow">{videoAtivo.titulo}</p>
                  <p className="text-white/70 text-sm mt-1">{videoAtivo.descricao}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Info do vídeo ativo */}
        <div className="flex items-center justify-between mb-4 px-1">
          <div>
            <p className="text-white font-semibold text-sm">{videoAtivo.titulo}</p>
            <p className="text-white/50 text-sm mt-0.5">{videoAtivo.descricao}</p>
          </div>
          <span className="text-white/30 text-xs whitespace-nowrap ml-4">{ativo + 1} / {videos.length}</span>
        </div>

        {/* Carrossel de miniaturas */}
        <div className="relative">
          {/* Seta esquerda */}
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-stone-700 hover:bg-amber-500 text-white transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>

          <div
            ref={carrosselRef}
            className="flex gap-3 overflow-x-auto scrollbar-hide scroll-smooth pb-1"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {videos.map((v, idx) => (
              <button
                key={v.id}
                onClick={() => handleSelect(idx)}
                className={`relative flex-shrink-0 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 ${
                  idx === ativo
                    ? 'ring-2 ring-amber-500 scale-[1.03]'
                    : 'opacity-60 hover:opacity-90'
                }`}
                style={{ width: '200px', height: '113px' }}
              >
                <img
                  src={v.thumb}
                  alt={v.titulo}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-black/40"></div>
                {/* Play icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-200 ${idx === ativo ? 'bg-amber-500' : 'bg-white/20'}`}>
                    <i className="ri-play-fill text-white text-sm ml-0.5"></i>
                  </div>
                </div>
                {/* Título */}
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-white text-xs font-semibold leading-tight line-clamp-2">{v.titulo}</p>
                </div>
              </button>
            ))}
          </div>

          {/* Seta direita */}
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-stone-700 hover:bg-amber-500 text-white transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>

        {/* Nota sobre os vídeos */}
        <p className="text-center text-white/30 text-xs mt-6">
          Vídeos hospedados em vidrosthelux.com.br/videos
        </p>
      </div>
    </section>
  );
}
